import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { StageDetailsType } from "../../../commonTypes/clientDirectoryTypes";

type AppProps = {
  modal: boolean;
  editData: StageDetailsType;
  setModal: Dispatch<SetStateAction<boolean>>;
  styleColor: any;
  handleSubmit: (data: any) => void;
};

const StageThresholdModal = ({
  modal,
  setModal,
  editData,
  styleColor,
  handleSubmit,
}: AppProps) => {
  const [thresholdDay, setThresholdDay] = useState<number>(0);

  const toggleModal = () => {
    setModal((prev: boolean) => !prev);
  };

  useEffect(() => {
    setThresholdDay(editData?.threshold_days);
  }, [editData]);

  return (
    <Modal isOpen={modal} toggle={toggleModal} size="sm">
    <ModalHeader toggle={toggleModal}>Edit Threshold Days</ModalHeader>
    <ModalBody>
      {/* Stage Name Display */}
      <div
        className="p-2 text-center"
        style={styleColor(editData?.stage_name ? editData?.stage_name : "")}
      >
       {editData?.stage_name}
      </div>
  
      {/* Days Input Field */}
      <div className="mt-3">
        <label htmlFor="thresholdDays" className="form-label">
          Days
        </label>
        <div className="d-flex align-items-center">
         
          <button
            className="btn btn-outline-secondary px-3"
            onClick={() => setThresholdDay((prev) => Math.max(0, prev - 1))}
          >
            -
          </button>
  
          
          <input
            type="number"
            id="thresholdDays"
            className="form-control text-center mx-2"
            style={{ maxWidth: "80px" }}
            onWheel={(e) => e.currentTarget.blur()}
            value={thresholdDay}
            min={0}
            onChange={(e) => setThresholdDay(Math.max(0, +e.target.value))}
          />
  
         
          <button
            className="btn btn-outline-secondary px-3"
            onClick={() => setThresholdDay((prev) => prev + 1)}
          >
            +
          </button>
        </div>
      </div>
    </ModalBody>
  
    
    <ModalFooter>
      <button className="btn btn-outline-secondary" onClick={toggleModal}>
        Cancel
      </button>
      <button
        className="btn btn-primary px-4"
        onClick={() => handleSubmit({ ...editData, thresholdDay })}
      >
        Save
      </button>
    </ModalFooter>
  </Modal>
  
  );
};

export default StageThresholdModal;
